import axios, {AxiosInstance, AxiosResponse} from 'axios';
import {API_BASE_URL} from '../../config';
import {store} from '../../app/store';

class AdminService {
  private token: string | undefined;
  private client: AxiosInstance | undefined;

  init() {
    const curStore = store.getState();
    this.token = curStore?.auth?.token;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: ''
    };
    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`;
    }

    this.client = axios.create({
      baseURL: `${API_BASE_URL}`,
      headers: headers,
    });
    return this.client;
  }

  /**
   * 获取用户列表
   */
  async getUsers() {
    return this.init().get(`/admin/users`);
  }
}

export default new AdminService();
